import Axios from 'axios';

export const axios = Axios.create({
  baseURL: `${window.env.API_ENDPOINT}api`, 
  headers: {
    'Content-Type': 'application/json',
  },
});
